import React from "react";

import { cn } from "@utils/utils";

import { Skeleton } from "@components/ui/skeleton";

interface TableLoaderProps {
  className?: string;
  colCount?: number;
}
const TableLoader: React.FC<TableLoaderProps> = ({
  className,
  colCount = 2,
}) => {
  return (
    <div
      data-testid="table-loader"
      className={cn("flex flex-col gap-y-5 p-10", className)}
    >
      {Array.from({ length: 5 }, (_, i) => {
        return (
          <div className="flex gap-2" key={i}>
            {Array(colCount)
              .fill(0)
              .map((_, index) => (
                <Skeleton key={index} className="w-full h-4" />
              ))}
          </div>
        );
      })}
    </div>
  );
};

export default TableLoader;
